import React from 'react';
import { styles } from './GoToLink.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { useTrackingContext } from '../Tracking';
import { Link } from '../PlatformFunctionality';

export type GoToLinkProps = {
  href: string;
  label: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  className?: string;
  shouldOpenInNewWindow?: boolean;
};

const ICON_SIZE = '0.875em';

export const GoToLink = ({ href, label, onClick, className, shouldOpenInNewWindow = false }: GoToLinkProps) => {
  const { tracker } = useTrackingContext();

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = event => {
    tracker.trackClick({ label, extraData: { moduleName: 'Listing block link' } });
    onClick?.(event);
  };

  return (
    <Link
      href={href}
      onClick={handleClick}
      className={classNames([styles.link, className])}
      {...(shouldOpenInNewWindow ? { target: '_blank', rel: 'noreferrer' } : {})}
    >
      {label}
      <Icon name="ArrowRight" width={ICON_SIZE} height={ICON_SIZE} className={styles.chevron} />
    </Link>
  );
};
